import { render } from "./ProjectManagement.vue?vue&type=template&id=f44cdab8&scoped=true"
import script from "./ProjectManagement.vue?vue&type=script&lang=js"
export * from "./ProjectManagement.vue?vue&type=script&lang=js"

import "./ProjectManagement.vue?vue&type=style&index=0&id=f44cdab8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f44cdab8"]])

export default __exports__